import Slider from '../Elements/Slider';

/**
 * MediaSlider
 */
export default class MediaSlider extends Slider {
  constructor($element) {
    super($element);

    this.$element = $element;

    this.bindHandlers();

    this.initialize({
      margin: 30,
      responsive: {
        0: {
          margin: 15
        },
        640: {
          margin: 30
        }
      }
    });
  }

  bindHandlers() {
    let _self = this;
    let slideIndex,
      visible;

    this.$element.on('initialized.owl.carousel translated.owl.carousel', function (e) {
      slideIndex = e.item.index;
      visible = parseInt(e.page.size);
    });

    this.$element.find('.media-element [data-fancybox="mediaslider"]').fancybox({
      animationEffect: 'fade',
      animationDuration: 500,
      beforeShow: function (e) {
        if (e.currIndex == slideIndex + 4 || e.currIndex <= slideIndex) {
          _self.$element.trigger("to.owl.carousel", e.currIndex);
        }
      }
    });
  }
}
